export const test_data = {
  data: {
    allWorks: [
      {
        userID: 32,
        FirstName: "Eyal",
        LastName: "Barta",
        Email: "eyalb@mis-implants.com",
        Pass:
          "7FF577E7832BDBFA00A10B7664DF535A4F8F3082E96BC23DDF0875C09079B501",
        Country: "165",
        Phone: "617-323-2514",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: "Maple st.",
        City: "West Roxbury",
        ZipCode: "02132",
        Phone2: "",
        StreetNo: "173",
        state: "",
        StatusName: "Created",
        StatusDesc: "Created orders",
        WorkOrderTypeDesc: "MLAB + MGUIDE",
        WO_ID: 12753,
        WO_number: null,
        AX_WO_number: "-1",
        WO_type_ID: 3,
        Doctor_user_ID: 32,
        Cust_name: "pt345636",
        Cust_birth_date: null,
        Order_date: "2020-07-07T10:22:23.917",
        Requested_implant_date: null,
        Actual_implant_date: "2020-07-16T21:00:00",
        Order_header: "ghndghndghndghndghn",
        Treating_doc: "7Z7RuJYPlVz7nqEgutHVzA==",
        StatusID: 1,
        comment: null,
        RestorationTypeID: -1,
        AdditionalIndicationsTypeID: 2,
        SO_number: null,
        LastStatusUpdate: "2020-07-07T13:23:58.237",
        Priority: null,
        distributor_id: 13,
        LastStatusUpdateUserID: 32,
        ServicesOptionsTypeID: null,
        Expr1: 32,
        Expr2: "Eyal",
        Expr3: "Barta",
        Treating_doc_mobile: "617-323-2514",
        Treating_doc_mail: "eyalb@mis-implants.com",
        Treating_doc_street: "Maple st.",
        Treating_doc_city: "West Roxbury",
        Treating_doc_state: "",
        Treating_doc_zipcode: "02132",
        MlabStoneModelTrackingNumber: null,
        MlabImpressionTrackingNumber: null,
        McenterDetailsId: 4,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        IsDoctorApprovedPresentation: null,
        IsPresentationComplete: null,
        WO_ID_ENC: "AK-eL0BUk9iHDV3aqI75gw=="
      }
    ],
    draftsOrders: [],
    ordersHistories: [
      {
        WOH_ID: 178,
        WO_ID: 12753,
        WO_number: null,
        AX_WO_number: "-1",
        WO_type_ID: 3,
        Doctor_user_ID: 32,
        Cust_name: "V6enu2qpMdQe7ZFiou9unA==",
        Cust_birth_date: null,
        Order_date: "2020-07-07T10:22:23.917",
        Requested_implant_date: null,
        Actual_implant_date: "2020-07-16T21:00:00",
        Order_header: "ghndghndghndghndghn",
        Treating_doc: "Eyal Barta",
        StatusID: 1,
        comment: null,
        RestorationTypeID: -1,
        AdditionalIndicationsTypeID: 2,
        ServicesOptionsTypeID: null,
        SO_number: null,
        LastStatusUpdate: "2020-07-07T13:23:58.237",
        Priority: null,
        LastStatusUpdateUserID: 32,
        Treating_doc_mobile: "617-323-2514",
        Treating_doc_mail: "eyalb@mis-implants.com",
        Treating_doc_street: "Maple st.",
        Treating_doc_city: "West Roxbury",
        Treating_doc_state: "",
        Treating_doc_zipcode: "02132",
        MlabStoneModelTrackingNumber: null,
        MlabImpressionTrackingNumber: null,
        McenterDetailsId: 4,
        StatusName: "Created",
        UpdaterName: "Eyal Barta",
        IsDoctorApprovedPresentation: null,
        IsPresentationComplete: null
      },
      {
        WOH_ID: 151,
        WO_ID: 12701,
        WO_number: null,
        AX_WO_number: "-1",
        WO_type_ID: 3,
        Doctor_user_ID: 32,
        Cust_name: null,
        Cust_birth_date: null,
        Order_date: "2020-03-05T13:34:34.42",
        Requested_implant_date: null,
        Actual_implant_date: "2020-03-18T22:00:00",
        Order_header: "BT - (ACF)",
        Treating_doc: "Eyal Barta",
        StatusID: 5,
        comment: "status update Designed",
        RestorationTypeID: -1,
        AdditionalIndicationsTypeID: 2,
        ServicesOptionsTypeID: null,
        SO_number: null,
        LastStatusUpdate: "2020-07-05T10:30:02.823",
        Priority: null,
        LastStatusUpdateUserID: 2,
        Treating_doc_mobile: "617-323-2514",
        Treating_doc_mail: "eyalb@mis-implants.com",
        Treating_doc_street: "Maple st.",
        Treating_doc_city: "West Roxbury",
        Treating_doc_state: "",
        Treating_doc_zipcode: "02132",
        MlabStoneModelTrackingNumber: "",
        MlabImpressionTrackingNumber: null,
        McenterDetailsId: 4,
        StatusName: "Shipped",
        UpdaterName: "Mcenter Mguide",
        IsDoctorApprovedPresentation: null,
        IsPresentationComplete: null
      },
      {
        WOH_ID: 153,
        WO_ID: 12701,
        WO_number: null,
        AX_WO_number: "-1",
        WO_type_ID: 3,
        Doctor_user_ID: 32,
        Cust_name: null,
        Cust_birth_date: null,
        Order_date: "2020-03-05T13:34:34.42",
        Requested_implant_date: null,
        Actual_implant_date: "2020-03-18T22:00:00",
        Order_header: "BT - (ACF)",
        Treating_doc: "Eyal Barta",
        StatusID: 5,
        comment: "status update Designed",
        RestorationTypeID: -1,
        AdditionalIndicationsTypeID: 2,
        ServicesOptionsTypeID: null,
        SO_number: null,
        LastStatusUpdate: "2020-07-05T10:31:14.867",
        Priority: null,
        LastStatusUpdateUserID: 2,
        Treating_doc_mobile: "617-323-2514",
        Treating_doc_mail: "eyalb@mis-implants.com",
        Treating_doc_street: "Maple st.",
        Treating_doc_city: "West Roxbury",
        Treating_doc_state: "",
        Treating_doc_zipcode: "02132",
        MlabStoneModelTrackingNumber: "",
        MlabImpressionTrackingNumber: null,
        McenterDetailsId: 4,
        StatusName: "Shipped",
        UpdaterName: "Mcenter Mguide",
        IsDoctorApprovedPresentation: null,
        IsPresentationComplete: null
      }
    ],
    misUsersList: [
      {
        userID: 1,
        FirstName: "admin",
        LastName: "MIS",
        Email: "admin@mly.co.il",
        Pass: "",
        Country: "1",
        Phone: "555",
        MobilePhone: null,
        Address: "555",
        userType: 1,
        userRole: "1",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 2,
        FirstName: "Mcenter",
        LastName: "Mguide",
        Email: "mguide@mis-implants.com",
        Pass: "",
        Country: "6",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 5,
        userRole: "5",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 3,
        FirstName: "MIS IBERIA",
        LastName: ".",
        Email: "IBERIA@mis-implants.com",
        Pass: "",
        Country: "199",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 4,
        FirstName: "MIS Implants Technologies GmbH",
        LastName: ".",
        Email: "GmbH@mis-implants.com",
        Pass: "",
        Country: "80",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 5,
        FirstName: "MIS Belgium",
        LastName: ".",
        Email: "Belgium@mis-implants.com",
        Pass: "",
        Country: "21",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 6,
        FirstName: "MIS Implants Technologies UK Limited",
        LastName: ".",
        Email: "England@mis-implants.com",
        Pass: "",
        Country: "225",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 7,
        FirstName: "MIS France",
        LastName: ".",
        Email: "France@mis-implants.com",
        Pass: "",
        Country: "73",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 8,
        FirstName: "Revello S.P.A",
        LastName: ".",
        Email: "Italy@mis-implants.com",
        Pass: "",
        Country: "105",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 9,
        FirstName: "MIS Implants Distribution SRL",
        LastName: ".",
        Email: "Romania@mis-implants.com",
        Pass: "",
        Country: "176",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 10,
        FirstName: "Misdent Implants Dis Urunleri Sanayi Ticaret  A.S",
        LastName: ".",
        Email: "Turkey@mis-implants.com",
        Pass: "",
        Country: "218",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 11,
        FirstName: " DVDENT",
        LastName: ".",
        Email: "Israel@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 12,
        FirstName: "MIS USA",
        LastName: ".",
        Email: "Canada@mis-implants.com",
        Pass: "",
        Country: "38",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 13,
        FirstName: "MIS Technology Panama, INC",
        LastName: ".",
        Email: "Panama@mis-implants.com",
        Pass: "",
        Country: "165",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 14,
        FirstName: "MIS Implants S.A.S",
        LastName: ".",
        Email: "Colombia@mis-implants.com",
        Pass: "",
        Country: "47",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 15,
        FirstName: "Distribuidora Dental S.A",
        LastName: ".",
        Email: "Guatemala@mis-implants.com",
        Pass: "",
        Country: "88",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 16,
        FirstName: "TOP DENTAL INTERNACIONAL",
        LastName: ".",
        Email: "Ecuador@mis-implants.com",
        Pass: "",
        Country: "62",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 17,
        FirstName: "Negrin In Dental",
        LastName: ".",
        Email: "Greece@mis-implants.com",
        Pass: "",
        Country: "83",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 18,
        FirstName: "IDS Sweden AB",
        LastName: ".",
        Email: "Sweden@mis-implants.com",
        Pass: "",
        Country: "205",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 19,
        FirstName: " ISS Implant Support Service",
        LastName: ".",
        Email: "SouthAfrica@mis-implants.com",
        Pass: "",
        Country: "197",
        Phone: "123",
        MobilePhone: null,
        Address: "123",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 20,
        FirstName: "David",
        LastName: "Norré",
        Email: "david.norre1@telenet.be",
        Pass: "",
        Country: "21",
        Phone: "0032497463875",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 21,
        FirstName: "MLY",
        LastName: "TEST REGISTER",
        Email: "dotanamor@gmail.com",
        Pass: "",
        Country: "21",
        Phone: "0507767440",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 22,
        FirstName: "Dentsply Ind. Com.",
        LastName: "LTDA",
        Email: "Lilian.andrade@dentsplysirona.com",
        Pass: "",
        Country: "30",
        Phone: "123",
        MobilePhone: "",
        Address: "1",
        userType: 3,
        userRole: "3",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 23,
        FirstName: "benjamin",
        LastName: "CORTASSE",
        Email: "benjamin.cortasse@orange.fr",
        Pass: "",
        Country: "73",
        Phone: "0632238883",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 24,
        FirstName: "Nitzan",
        LastName: "Bichacho",
        Email: "nitzan@bichacho.net",
        Pass: "",
        Country: "104",
        Phone: "036050060",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 25,
        FirstName: "te",
        LastName: "te",
        Email: "dotan+doc@mly.co.il",
        Pass: "",
        Country: "104",
        Phone: "0507767440",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 26,
        FirstName: "Warehouse",
        LastName: "Warehouse",
        Email: "wh@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "0507767444",
        MobilePhone: null,
        Address: null,
        userType: 6,
        userRole: "6",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 27,
        FirstName: "Ori",
        LastName: "Rozenberg",
        Email: "orir@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "0546939401",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 28,
        FirstName: "AA11",
        LastName: "BB",
        Email: "info+15@mly.co.il",
        Pass: "",
        Country: "104",
        Phone: "987",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 29,
        FirstName: "Anat",
        LastName: "Darom Carmon",
        Email: "anat.da@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "0546939401",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 30,
        FirstName: "Marina",
        LastName: "Steinberg",
        Email: "steinberg_marina@yahoo.com",
        Pass: "",
        Country: "104",
        Phone: "052-61266554",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 31,
        FirstName: "Dubix",
        LastName: "Sharonx",
        Email: "dubi@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "0503344004",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 32,
        FirstName: "Eyal",
        LastName: "Barta",
        Email: "eyalb@mis-implants.com",
        Pass: "",
        Country: "165",
        Phone: "617-323-2514",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 33,
        FirstName: "Orit",
        LastName: "Kario",
        Email: "korit@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "12345678",
        MobilePhone: null,
        Address: null,
        userType: 5,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 34,
        FirstName: "mis",
        LastName: "test",
        Email: "test@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "test@mis-implants.com",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 35,
        FirstName: "John",
        LastName: "Doe",
        Email: "ori22279@gmail.com",
        Pass: "",
        Country: "225",
        Phone: "+447887644118",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 37,
        FirstName: "admin",
        LastName: "Moran",
        Email: "moran.r@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "555",
        MobilePhone: null,
        Address: "555",
        userType: 1,
        userRole: "1",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 40,
        FirstName: "Artur",
        LastName: "Blinder",
        Email: "artur@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: "123",
        MobilePhone: null,
        Address: null,
        userType: 4,
        userRole: "5",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 42,
        FirstName: "Alona",
        LastName: "M",
        Email: "alona@mis-implants.com   ",
        Pass: "",
        Country: "104",
        Phone: "123",
        MobilePhone: null,
        Address: null,
        userType: 6,
        userRole: "5",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 43,
        FirstName: "Nada",
        LastName: "M",
        Email: "nada@mis-implants.com    ",
        Pass: "",
        Country: "104",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: 6,
        userRole: "5",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 46,
        FirstName: "Moranr",
        LastName: "R",
        Email: "moranr@mis-implants.com",
        Pass: "",
        Country: "104",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: 5,
        userRole: "5",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 48,
        FirstName: "Mcenter",
        LastName: "Berlin",
        Email: "msb@mis-implants.com",
        Pass: "",
        Country: "80",
        Phone: "000",
        MobilePhone: null,
        Address: null,
        userType: 5,
        userRole: "5",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 49,
        FirstName: "Dubi",
        LastName: "Berlin",
        Email: "dubi_berlin@mis-implants.com",
        Pass: "",
        Country: "80",
        Phone: "111",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 50,
        FirstName: "xxx",
        LastName: "xxx",
        Email: "mguidexxx@mis-implants.com",
        Pass: "",
        Country: "80",
        Phone: "1",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 51,
        FirstName: "Murvet",
        LastName: "Yildiz",
        Email: "dtmurry@hotmail.com",
        Pass: "",
        Country: "218",
        Phone: "00905019071982",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 52,
        FirstName: "Thomas",
        LastName: "De Peuter",
        Email: "thomas@kwadrant.biz",
        Pass: "",
        Country: "21",
        Phone: "+32475637049",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 53,
        FirstName: "galip",
        LastName: "gurel",
        Email: "murvet.kolemen@dentalkampus.com",
        Pass: "",
        Country: "218",
        Phone: "00905019071982",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 54,
        FirstName: "Jakub",
        LastName: "Krmela",
        Email: "jakub.krmela@gmail.com",
        Pass: "",
        Country: "57",
        Phone: "jakub.krmela@gmail.com",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 55,
        FirstName: "Ami",
        LastName: "Smidt",
        Email: "ami@smidt.co.il",
        Pass: "",
        Country: "104",
        Phone: "036412326",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 56,
        FirstName: "Kris",
        LastName: "Eelen",
        Email: "praktijk@toreel.be",
        Pass: "",
        Country: "21",
        Phone: "+32(0)15515820",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 57,
        FirstName: "Johannes",
        LastName: "Tromp",
        Email: "admin@dentalhealthforlife.co.uk",
        Pass: "",
        Country: "225",
        Phone: "admin@dentalhealthforlife.co.uk",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 58,
        FirstName: "Orit",
        LastName: "Jacobi",
        Email: "orit.kario@gmail.com",
        Pass: "",
        Country: "80",
        Phone: "555555555555",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      },
      {
        userID: 59,
        FirstName: "Dubix",
        LastName: "Sharonix",
        Email: "dubi.shr@gmail.com",
        Pass: "",
        Country: "80",
        Phone: "123",
        MobilePhone: null,
        Address: null,
        userType: 2,
        userRole: "2",
        Active: true,
        Street: null,
        City: null,
        ZipCode: null,
        StreetNo: null,
        Phone2: null,
        State: null,
        DistributorID: 0,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null,
        McenterDetailsId: 0
      }
    ],
    misDistrabutorList: [
      {
        userID: 3,
        FirstName: "MIS IBERIA",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "199",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 4,
        FirstName: "MIS Implants Technologies GmbH",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "80",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 5,
        FirstName: "MIS Belgium",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "21",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 6,
        FirstName: "MIS Implants Technologies UK Limited",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "225",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 7,
        FirstName: "MIS France",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "73",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 8,
        FirstName: "Revello S.P.A",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "105",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 9,
        FirstName: "MIS Implants Distribution SRL",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "176",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 10,
        FirstName: "Misdent Implants Dis Urunleri Sanayi Ticaret  A.S",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "218",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 11,
        FirstName: " DVDENT",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "104",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 12,
        FirstName: "MIS USA",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "38",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 13,
        FirstName: "MIS Technology Panama, INC",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "165",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 14,
        FirstName: "MIS Implants S.A.S",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "47",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 15,
        FirstName: "Distribuidora Dental S.A",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "88",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 16,
        FirstName: "TOP DENTAL INTERNACIONAL",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "62",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 17,
        FirstName: "Negrin In Dental",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "83",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 18,
        FirstName: "IDS Sweden AB",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "205",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 19,
        FirstName: " ISS Implant Support Service",
        LastName: ".",
        Email: null,
        Pass: null,
        Country: "197",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      },
      {
        userID: 22,
        FirstName: "Dentsply Ind. Com.",
        LastName: "LTDA",
        Email: null,
        Pass: null,
        Country: "30",
        Phone: null,
        MobilePhone: null,
        Address: null,
        userType: null,
        userRole: null,
        Active: false,
        Street: null,
        City: null,
        ZipCode: null,
        Phone2: null,
        StreetNo: null,
        state: null,
        LastLoginTimestamps: null,
        LoginPasswordResetDate: null
      }
    ],
    statuses: [
      {
        StatusID: 1,
        StatusName: "Created",
        StatusDesc: "Created orders",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 2,
        StatusName: "Planned",
        StatusDesc: "Planned",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 3,
        StatusName: "Approved",
        StatusDesc: "Approved",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 4,
        StatusName: "Produced",
        StatusDesc: "Produced",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 5,
        StatusName: "Shipped",
        StatusDesc: "Shipped",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 6,
        StatusName: "Cancelled",
        StatusDesc: "Cancelled",
        IsShowDropBox: false,
        IsShowDashboard: true
      },
      {
        StatusID: 8,
        StatusName: "Done",
        StatusDesc: "Done",
        IsShowDropBox: false,
        IsShowDashboard: false
      }
    ],
    Countries: [
      {
        CountryID: 10,
        Country: "ARGENTINA",
        Iso2: "AR",
        Nicename: "Argentina",
        Iso3: "ARG",
        Numcode: 32,
        Phonecode: 54,
        isActive: 1
      },
      {
        CountryID: 11,
        Country: "ARMENIA",
        Iso2: "AM",
        Nicename: "Armenia",
        Iso3: "ARM",
        Numcode: 51,
        Phonecode: 374,
        isActive: 1
      },
      {
        CountryID: 13,
        Country: "AUSTRALIA",
        Iso2: "AU",
        Nicename: "Australia",
        Iso3: "AUS",
        Numcode: 36,
        Phonecode: 61,
        isActive: 1
      },
      {
        CountryID: 14,
        Country: "AUSTRIA",
        Iso2: "AT",
        Nicename: "Austria",
        Iso3: "AUT",
        Numcode: 40,
        Phonecode: 43,
        isActive: 1
      },
      {
        CountryID: 15,
        Country: "AZERBAIJAN",
        Iso2: "AZ",
        Nicename: "Azerbaijan",
        Iso3: "AZE",
        Numcode: 31,
        Phonecode: 994,
        isActive: 1
      },
      {
        CountryID: 20,
        Country: "BELARUS",
        Iso2: "BY",
        Nicename: "Belarus",
        Iso3: "BLR",
        Numcode: 112,
        Phonecode: 375,
        isActive: 1
      },
      {
        CountryID: 21,
        Country: "BELGIUM",
        Iso2: "BE",
        Nicename: "Belgium",
        Iso3: "BEL",
        Numcode: 56,
        Phonecode: 32,
        isActive: 1
      },
      {
        CountryID: 26,
        Country: "BOLIVIA",
        Iso2: "BO",
        Nicename: "Bolivia",
        Iso3: "BOL",
        Numcode: 68,
        Phonecode: 591,
        isActive: 1
      },
      {
        CountryID: 33,
        Country: "BULGARIA",
        Iso2: "BG",
        Nicename: "Bulgaria",
        Iso3: "BGR",
        Numcode: 100,
        Phonecode: 359,
        isActive: 1
      },
      {
        CountryID: 38,
        Country: "CANADA",
        Iso2: "CA",
        Nicename: "Canada",
        Iso3: "CAN",
        Numcode: 124,
        Phonecode: 1,
        isActive: 1
      },
      {
        CountryID: 43,
        Country: "CHILE",
        Iso2: "CL",
        Nicename: "Chile",
        Iso3: "CHL",
        Numcode: 152,
        Phonecode: 56,
        isActive: 1
      },
      {
        CountryID: 44,
        Country: "CHINA",
        Iso2: "CN",
        Nicename: "China",
        Iso3: "CHN",
        Numcode: 156,
        Phonecode: 86,
        isActive: 1
      },
      {
        CountryID: 47,
        Country: "COLOMBIA",
        Iso2: "CO",
        Nicename: "Colombia",
        Iso3: "COL",
        Numcode: 170,
        Phonecode: 57,
        isActive: 1
      },
      {
        CountryID: 52,
        Country: "COSTA RICA",
        Iso2: "CR",
        Nicename: "Costa Rica",
        Iso3: "CRI",
        Numcode: 188,
        Phonecode: 506,
        isActive: 1
      },
      {
        CountryID: 54,
        Country: "CROATIA",
        Iso2: "HR",
        Nicename: "Croatia",
        Iso3: "HRV",
        Numcode: 191,
        Phonecode: 385,
        isActive: 1
      },
      {
        CountryID: 56,
        Country: "CYPRUS",
        Iso2: "CY",
        Nicename: "Cyprus",
        Iso3: "CYP",
        Numcode: 196,
        Phonecode: 357,
        isActive: 1
      },
      {
        CountryID: 57,
        Country: "CZECH REPUBLIC",
        Iso2: "CZ",
        Nicename: "Czech Republic",
        Iso3: "CZE",
        Numcode: 203,
        Phonecode: 420,
        isActive: 1
      },
      {
        CountryID: 61,
        Country: "DOMINICAN REPUBLIC",
        Iso2: "DO",
        Nicename: "Dominican Republic",
        Iso3: "DOM",
        Numcode: 214,
        Phonecode: 1809,
        isActive: 1
      },
      {
        CountryID: 62,
        Country: "ECUADOR",
        Iso2: "EC",
        Nicename: "Ecuador",
        Iso3: "ECU",
        Numcode: 218,
        Phonecode: 593,
        isActive: 1
      },
      {
        CountryID: 64,
        Country: "EL SALVADOR",
        Iso2: "SV",
        Nicename: "El Salvador",
        Iso3: "SLV",
        Numcode: 222,
        Phonecode: 503,
        isActive: 1
      },
      {
        CountryID: 72,
        Country: "FINLAND",
        Iso2: "FI",
        Nicename: "Finland",
        Iso3: "FIN",
        Numcode: 246,
        Phonecode: 358,
        isActive: 1
      },
      {
        CountryID: 73,
        Country: "FRANCE",
        Iso2: "FR",
        Nicename: "France",
        Iso3: "FRA",
        Numcode: 250,
        Phonecode: 33,
        isActive: 1
      },
      {
        CountryID: 79,
        Country: "GEORGIA",
        Iso2: "GE",
        Nicename: "Georgia",
        Iso3: "GEO",
        Numcode: 268,
        Phonecode: 995,
        isActive: 1
      },
      {
        CountryID: 80,
        Country: "GERMANY",
        Iso2: "DE",
        Nicename: "Germany",
        Iso3: "DEU",
        Numcode: 276,
        Phonecode: 49,
        isActive: 1
      },
      {
        CountryID: 83,
        Country: "GREECE",
        Iso2: "GR",
        Nicename: "Greece",
        Iso3: "GRC",
        Numcode: 300,
        Phonecode: 30,
        isActive: 1
      },
      {
        CountryID: 88,
        Country: "GUATEMALA",
        Iso2: "GT",
        Nicename: "Guatemala",
        Iso3: "GTM",
        Numcode: 320,
        Phonecode: 502,
        isActive: 1
      },
      {
        CountryID: 95,
        Country: "HONDURAS",
        Iso2: "HN",
        Nicename: "Honduras",
        Iso3: "HND",
        Numcode: 340,
        Phonecode: 504,
        isActive: 1
      },
      {
        CountryID: 96,
        Country: "HONG KONG",
        Iso2: "HK",
        Nicename: "Hong Kong",
        Iso3: "HKG",
        Numcode: 344,
        Phonecode: 852,
        isActive: 1
      },
      {
        CountryID: 99,
        Country: "INDIA",
        Iso2: "IN",
        Nicename: "India",
        Iso3: "IND",
        Numcode: 356,
        Phonecode: 91,
        isActive: 1
      },
      {
        CountryID: 100,
        Country: "INDONESIA",
        Iso2: "ID",
        Nicename: "Indonesia",
        Iso3: "IDN",
        Numcode: 360,
        Phonecode: 62,
        isActive: 1
      },
      {
        CountryID: 104,
        Country: "ISRAEL",
        Iso2: "IL",
        Nicename: "Israel",
        Iso3: "ISR",
        Numcode: 376,
        Phonecode: 972,
        isActive: 1
      },
      {
        CountryID: 105,
        Country: "ITALY",
        Iso2: "IT",
        Nicename: "Italy",
        Iso3: "ITA",
        Numcode: 380,
        Phonecode: 39,
        isActive: 1
      },
      {
        CountryID: 107,
        Country: "JAPAN",
        Iso2: "JP",
        Nicename: "Japan",
        Iso3: "JPN",
        Numcode: 392,
        Phonecode: 81,
        isActive: 1
      },
      {
        CountryID: 109,
        Country: "KAZAKHSTAN",
        Iso2: "KZ",
        Nicename: "Kazakhstan",
        Iso3: "KAZ",
        Numcode: 398,
        Phonecode: 7,
        isActive: 1
      },
      {
        CountryID: 249,
        Country: "KOSOVO",
        Iso2: "XK",
        Nicename: "Kosovo",
        Iso3: "---",
        Numcode: 0,
        Phonecode: 381,
        isActive: 1
      },
      {
        CountryID: 123,
        Country: "LITHUANIA",
        Iso2: "LT",
        Nicename: "Lithuania",
        Iso3: "LTU",
        Numcode: 440,
        Phonecode: 370,
        isActive: 1
      },
      {
        CountryID: 126,
        Country: "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
        Iso2: "MK",
        Nicename: "Macedonia, the Former Yugoslav Republic of",
        Iso3: "MKD",
        Numcode: 807,
        Phonecode: 389,
        isActive: 1
      },
      {
        CountryID: 138,
        Country: "MEXICO",
        Iso2: "MX",
        Nicename: "Mexico",
        Iso3: "MEX",
        Numcode: 484,
        Phonecode: 52,
        isActive: 1
      },
      {
        CountryID: 144,
        Country: "MOROCCO",
        Iso2: "MA",
        Nicename: "Morocco",
        Iso3: "MAR",
        Numcode: 504,
        Phonecode: 212,
        isActive: 1
      },
      {
        CountryID: 150,
        Country: "NETHERLANDS",
        Iso2: "NL",
        Nicename: "Netherlands",
        Iso3: "NLD",
        Numcode: 528,
        Phonecode: 31,
        isActive: 1
      },
      {
        CountryID: 154,
        Country: "NICARAGUA",
        Iso2: "NI",
        Nicename: "Nicaragua",
        Iso3: "NIC",
        Numcode: 558,
        Phonecode: 505,
        isActive: 1
      },
      {
        CountryID: 165,
        Country: "PANAMA",
        Iso2: "PA",
        Nicename: "Panama",
        Iso3: "PAN",
        Numcode: 591,
        Phonecode: 507,
        isActive: 1
      },
      {
        CountryID: 167,
        Country: "PARAGUAY",
        Iso2: "PY",
        Nicename: "Paraguay",
        Iso3: "PRY",
        Numcode: 600,
        Phonecode: 595,
        isActive: 1
      },
      {
        CountryID: 168,
        Country: "PERU",
        Iso2: "PE",
        Nicename: "Peru",
        Iso3: "PER",
        Numcode: 604,
        Phonecode: 51,
        isActive: 1
      },
      {
        CountryID: 169,
        Country: "PHILIPPINES",
        Iso2: "PH",
        Nicename: "Philippines",
        Iso3: "PHL",
        Numcode: 608,
        Phonecode: 63,
        isActive: 1
      },
      {
        CountryID: 171,
        Country: "POLAND",
        Iso2: "PL",
        Nicename: "Poland",
        Iso3: "POL",
        Numcode: 616,
        Phonecode: 48,
        isActive: 1
      },
      {
        CountryID: 172,
        Country: "PORTUGAL",
        Iso2: "PT",
        Nicename: "Portugal",
        Iso3: "PRT",
        Numcode: 620,
        Phonecode: 351,
        isActive: 1
      },
      {
        CountryID: 176,
        Country: "ROMANIA",
        Iso2: "RO",
        Nicename: "Romania",
        Iso3: "ROM",
        Numcode: 642,
        Phonecode: 40,
        isActive: 1
      },
      {
        CountryID: 177,
        Country: "RUSSIAN FEDERATION",
        Iso2: "RU",
        Nicename: "Russian Federation",
        Iso3: "RUS",
        Numcode: 643,
        Phonecode: 70,
        isActive: 1
      },
      {
        CountryID: 240,
        Country: "SERBIA",
        Iso2: "RS",
        Nicename: "Serbia",
        Iso3: "SRB",
        Numcode: 688,
        Phonecode: 381,
        isActive: 1
      },
      {
        CountryID: 197,
        Country: "SOUTH AFRICA",
        Iso2: "ZA",
        Nicename: "South Africa",
        Iso3: "ZAF",
        Numcode: 710,
        Phonecode: 27,
        isActive: 1
      },
      {
        CountryID: 199,
        Country: "SPAIN",
        Iso2: "ES",
        Nicename: "Spain",
        Iso3: "ESP",
        Numcode: 724,
        Phonecode: 34,
        isActive: 1
      },
      {
        CountryID: 205,
        Country: "SWEDEN",
        Iso2: "SE",
        Nicename: "Sweden",
        Iso3: "SWE",
        Numcode: 752,
        Phonecode: 46,
        isActive: 1
      },
      {
        CountryID: 208,
        Country: "TAIWAN, PROVINCE OF CHINA",
        Iso2: "TW",
        Nicename: "Taiwan, Province of China",
        Iso3: "TWN",
        Numcode: 158,
        Phonecode: 886,
        isActive: 1
      },
      {
        CountryID: 211,
        Country: "THAILAND",
        Iso2: "TH",
        Nicename: "Thailand",
        Iso3: "THA",
        Numcode: 764,
        Phonecode: 66,
        isActive: 1
      },
      {
        CountryID: 218,
        Country: "TURKEY",
        Iso2: "TR",
        Nicename: "Turkey",
        Iso3: "TUR",
        Numcode: 792,
        Phonecode: 90,
        isActive: 1
      },
      {
        CountryID: 223,
        Country: "UKRAINE",
        Iso2: "UA",
        Nicename: "Ukraine",
        Iso3: "UKR",
        Numcode: 804,
        Phonecode: 380,
        isActive: 1
      },
      {
        CountryID: 225,
        Country: "UNITED KINGDOM",
        Iso2: "GB",
        Nicename: "United Kingdom",
        Iso3: "GBR",
        Numcode: 826,
        Phonecode: 44,
        isActive: 1
      },
      {
        CountryID: 226,
        Country: "UNITED STATES",
        Iso2: "US",
        Nicename: "United States",
        Iso3: "USA",
        Numcode: 840,
        Phonecode: 1,
        isActive: 1
      },
      {
        CountryID: 231,
        Country: "VENEZUELA",
        Iso2: "VE",
        Nicename: "Venezuela",
        Iso3: "VEN",
        Numcode: 862,
        Phonecode: 58,
        isActive: 1
      },
      {
        CountryID: 232,
        Country: "VIET NAM",
        Iso2: "VN",
        Nicename: "Viet Nam",
        Iso3: "VNM",
        Numcode: 704,
        Phonecode: 84,
        isActive: 1
      }
    ],
    mcenter_Users: [
      {
        id: 30,
        McenterDetailsId: 4,
        UserId: 32,
        IsActive: true,
        CreatedTs: "2020-03-05T15:05:32.247"
      }
    ],
    mcenterDetails: [
      {
        id: 4,
        McenterName: "MCENTER HQ",
        McenterAddress:
          "MIS Implant Technologies LTD, Bar-Lev indudtrial park, Misgav ISRAEL",
        McenterPhone: "+972-4-9016800",
        McenterMail: "mguide@mis-implants.com",
        McenterCreatedTimeStamp: "2019-11-12T08:57:47.32",
        McenterCreatedUserId: 1,
        isActive: 1
      },
      {
        id: 5,
        McenterName: "MCenter Europe",
        McenterAddress: "Kaiserin-Augusta Allee 112\r\n10553 Berlin\r\n",
        McenterPhone: "000",
        McenterMail: "emilb@mis-implants.com",
        McenterCreatedTimeStamp: "2020-06-25T08:12:16.513",
        McenterCreatedUserId: 1,
        isActive: 1
      }
    ]
  },
  status: { StatusCode: 200, StatusDescription: null }
};

export const tooth_table_data = [
  { ToothID: 1, ToothNumberADA: 1, ToothImage: null, ToothNumberFDI: 18 },
  { ToothID: 2, ToothNumberADA: 2, ToothImage: null, ToothNumberFDI: 17 },
  { ToothID: 3, ToothNumberADA: 3, ToothImage: null, ToothNumberFDI: 16 },
  { ToothID: 4, ToothNumberADA: 4, ToothImage: null, ToothNumberFDI: 15 },
  { ToothID: 5, ToothNumberADA: 5, ToothImage: null, ToothNumberFDI: 14 },
  { ToothID: 6, ToothNumberADA: 6, ToothImage: null, ToothNumberFDI: 13 },
  { ToothID: 7, ToothNumberADA: 7, ToothImage: null, ToothNumberFDI: 12 },
  { ToothID: 8, ToothNumberADA: 8, ToothImage: null, ToothNumberFDI: 11 },
  { ToothID: 9, ToothNumberADA: 9, ToothImage: null, ToothNumberFDI: 21 },
  { ToothID: 10, ToothNumberADA: 10, ToothImage: null, ToothNumberFDI: 22 },
  { ToothID: 11, ToothNumberADA: 11, ToothImage: null, ToothNumberFDI: 23 },
  { ToothID: 12, ToothNumberADA: 12, ToothImage: null, ToothNumberFDI: 24 },
  { ToothID: 13, ToothNumberADA: 13, ToothImage: null, ToothNumberFDI: 25 },
  { ToothID: 14, ToothNumberADA: 14, ToothImage: null, ToothNumberFDI: 26 },
  { ToothID: 15, ToothNumberADA: 15, ToothImage: null, ToothNumberFDI: 27 },
  { ToothID: 16, ToothNumberADA: 16, ToothImage: null, ToothNumberFDI: 28 },
  { ToothID: 17, ToothNumberADA: 17, ToothImage: null, ToothNumberFDI: 38 },
  { ToothID: 18, ToothNumberADA: 18, ToothImage: null, ToothNumberFDI: 37 },
  { ToothID: 19, ToothNumberADA: 19, ToothImage: null, ToothNumberFDI: 36 },
  { ToothID: 20, ToothNumberADA: 20, ToothImage: null, ToothNumberFDI: 35 },
  { ToothID: 21, ToothNumberADA: 21, ToothImage: null, ToothNumberFDI: 34 },
  { ToothID: 22, ToothNumberADA: 22, ToothImage: null, ToothNumberFDI: 33 },
  { ToothID: 23, ToothNumberADA: 23, ToothImage: null, ToothNumberFDI: 32 },
  { ToothID: 24, ToothNumberADA: 24, ToothImage: null, ToothNumberFDI: 31 },
  { ToothID: 25, ToothNumberADA: 25, ToothImage: null, ToothNumberFDI: 41 },
  { ToothID: 26, ToothNumberADA: 26, ToothImage: null, ToothNumberFDI: 42 },
  { ToothID: 27, ToothNumberADA: 27, ToothImage: null, ToothNumberFDI: 43 },
  { ToothID: 28, ToothNumberADA: 28, ToothImage: null, ToothNumberFDI: 44 },
  { ToothID: 29, ToothNumberADA: 29, ToothImage: null, ToothNumberFDI: 45 },
  { ToothID: 30, ToothNumberADA: 30, ToothImage: null, ToothNumberFDI: 46 },
  { ToothID: 31, ToothNumberADA: 31, ToothImage: null, ToothNumberFDI: 47 },
  { ToothID: 32, ToothNumberADA: 32, ToothImage: null, ToothNumberFDI: 48 }
];

export const order_data = {
  data: {
    WorkOrdersHistory: [
      {
        WOH_ID: 178,
        WO_ID: 12753,
        WO_number: null,
        AX_WO_number: "-1",
        WO_type_ID: 3,
        Doctor_user_ID: 32,
        Cust_name: "V6enu2qpMdQe7ZFiou9unA==",
        Cust_birth_date: null,
        Order_date: "2020-07-07T10:22:23.917",
        Requested_implant_date: null,
        Actual_implant_date: "2020-07-16T21:00:00",
        Order_header: "ghndghndghndghndghn",
        Treating_doc: "Eyal Barta",
        StatusID: 1,
        comment: null,
        RestorationTypeID: -1,
        AdditionalIndicationsTypeID: 2,
        ServicesOptionsTypeID: null,
        SO_number: null,
        LastStatusUpdate: "2020-07-07T13:23:58.237",
        Priority: null,
        LastStatusUpdateUserID: 32,
        Treating_doc_mobile: "617-323-2514",
        Treating_doc_mail: "eyalb@mis-implants.com",
        Treating_doc_street: "Maple st.",
        Treating_doc_city: "West Roxbury",
        Treating_doc_state: "",
        Treating_doc_zipcode: "02132",
        MlabStoneModelTrackingNumber: null,
        MlabImpressionTrackingNumber: null,
        McenterDetailsId: 4,
        StatusName: "Created",
        UpdaterName: "Eyal Barta",
        IsDoctorApprovedPresentation: null,
        IsPresentationComplete: null
      }
    ],
    WorkOrderCountryName: "PANAMA",
    WorkOrder: {
      WO_ID: 12753,
      WO_number: null,
      AX_WO_number: "-1",
      WO_type_ID: 3,
      Doctor_user_ID: 32,
      Cust_name: "pt345636",
      Cust_birth_date: null,
      Order_date: "2020-07-07T10:22:23.917",
      Requested_implant_date: null,
      Actual_implant_date: "2020-07-16T21:00:00",
      Order_header: "ghndghndghndghndghn",
      Treating_doc: "Eyal Barta",
      StatusID: 1,
      comment: null,
      RestorationTypeID: -1,
      AdditionalIndicationsTypeID: 2,
      ServicesOptionsTypeID: null,
      SO_number: null,
      LastStatusUpdate: "2020-07-07T13:23:58.237",
      Priority: null,
      LastStatusUpdateUserID: 32,
      Treating_doc_mobile: "617-323-2514",
      Treating_doc_mail: "eyalb@mis-implants.com",
      Treating_doc_street: "Maple st.",
      Treating_doc_city: "West Roxbury",
      Treating_doc_state: "",
      Treating_doc_zipcode: "02132",
      MlabStoneModelTrackingNumber: null,
      MlabImpressionTrackingNumber: null,
      McenterDetailsId: 4,
      IsDoctorApprovedPresentation: null,
      IsPresentationComplete: null,
      Treating_doc_country: "165",
      Treating_doc_streetNo: "173"
    },
    CementedToRestorationTypes: [
      { id: 0, name: "NONE", isActive: 1, tiBaseMultiUnitType_ids: "0" },
      {
        id: 1,
        name: "Pre Cemented to Restoration",
        isActive: 1,
        tiBaseMultiUnitType_ids: "1,2,3,4,5,6"
      },
      {
        id: 2,
        name: "Not Pre Cemented to restoration",
        isActive: 1,
        tiBaseMultiUnitType_ids: "1,2,3,4,5,6"
      }
    ],
    BridgeCrownTypes: [
      {
        id: 0,
        name: "NONE",
        restorationType_ids: "1,2,3,4,5,6",
        isActive: 1,
        requireTwoClosedTheeth: 0
      },
      {
        id: 1,
        name: "Bridge",
        restorationType_ids: "1,2,3,4,5,6",
        isActive: 1,
        requireTwoClosedTheeth: 0
      },
      {
        id: 2,
        name: "Crown",
        restorationType_ids: "1,2,3,4,5,6",
        isActive: 1,
        requireTwoClosedTheeth: 0
      },
      {
        id: 3,
        name: "Splinted Crowns",
        restorationType_ids: "1,2,3,4,5,6",
        isActive: 1,
        requireTwoClosedTheeth: 0
      },
      {
        id: 4,
        name: "Bridge+Crown",
        restorationType_ids: "1,2,3,4,5,6",
        isActive: 0,
        requireTwoClosedTheeth: 0
      },
      {
        id: 5,
        name: "Bridge+Splinted Crowns",
        restorationType_ids: null,
        isActive: 0,
        requireTwoClosedTheeth: 0
      },
      {
        id: 6,
        name: "Crown+Splinted Crowns",
        restorationType_ids: null,
        isActive: 0,
        requireTwoClosedTheeth: 0
      },
      {
        id: 7,
        name: "Bridge+Crown+Splinted Crowns",
        restorationType_ids: null,
        isActive: 0,
        requireTwoClosedTheeth: 0
      }
    ],
    ImplantTypes: [
      { value: null, label: "" },
      { value: 1, label: "SEVEN" },
      { value: 2, label: "C1" },
      { value: 3, label: "V3" },
      { value: 7, label: "C1B" },
      { value: 8, label: "V3B" }
    ],
    LengthTypes: [
      { value: null, label: "" },
      { value: 1, label: "6 mm" },
      { value: 2, label: "8 mm" },
      { value: 3, label: "10 mm" },
      { value: 4, label: "11.5mm" },
      { value: 5, label: "13 mm" },
      { value: 6, label: "16mm" }
    ],
    MaterialTypes: [
      { id: 1, name: "PMMA MultiLayer", isActive: 1 },
      { id: 2, name: "Zirconia", isActive: 1 },
      { id: 3, name: "Titanium", isActive: 1 }
    ],
    PlatformTypes: [
      { id: 1, name: "NP", isActive: 1 },
      { id: 2, name: "SP", isActive: 1 },
      { id: 3, name: "WP", isActive: 1 }
    ],
    PonticDesignTypes: [
      { id: 1, name: "Concave", isActive: 1 },
      { id: 2, name: "Convex", isActive: 1 }
    ],
    RestorationTypes: [
      {
        id: 1,
        name: "Custom Temporary Healing Cap",
        matrial_ids: "1,3",
        isActive: 1
      },
      {
        id: 2,
        name: "Custom Temporary Abutment",
        matrial_ids: "1",
        isActive: 1
      },
      { id: 3, name: "Custom Temporary Crown", matrial_ids: "1", isActive: 1 },
      { id: 4, name: "Custom Abutment", matrial_ids: "2,3", isActive: 1 },
      { id: 5, name: "Custom Anatomic Crown", matrial_ids: "2", isActive: 1 },
      { id: 6, name: "Crown + Abutment", matrial_ids: "1,2,3", isActive: 1 }
    ],
    ScrewCementTypes: [
      { id: 0, name: "NONE", isActive: 1, bridgeCrownType_ids: "0,1,2,3" },
      {
        id: 1,
        name: "Screw-Retained Restoration",
        isActive: 1,
        bridgeCrownType_ids: "0,1,2,3"
      },
      {
        id: 2,
        name: "Cement-Retained Restoration",
        isActive: 1,
        bridgeCrownType_ids: "0,1,2,3"
      }
    ],
    ServicesOptionsTypes: [
      { id: 1, name: "Standart", isActive: 1 },
      { id: 2, name: "Option 2", isActive: 1 },
      { id: 3, name: "Option 3", isActive: 1 }
    ],
    ShadeTypes: [
      { id: 1, name: "L", isActive: 1 },
      { id: 2, name: "M", isActive: 1 },
      { id: 3, name: "D", isActive: 1 }
    ],
    ShadeTypeTypes: [
      { id: 1, name: "A1", isActive: 1, shade_type_id: 1 },
      { id: 2, name: "B1", isActive: 1, shade_type_id: 1 },
      { id: 3, name: "C1", isActive: 1, shade_type_id: 1 },
      { id: 4, name: "D1", isActive: 1, shade_type_id: 1 },
      { id: 5, name: "A2", isActive: 1, shade_type_id: 2 },
      { id: 6, name: "B2", isActive: 1, shade_type_id: 2 },
      { id: 7, name: "C2", isActive: 1, shade_type_id: 2 },
      { id: 8, name: "D2", isActive: 1, shade_type_id: 2 },
      { id: 9, name: "A3", isActive: 1, shade_type_id: 2 },
      { id: 10, name: "B3", isActive: 1, shade_type_id: 2 },
      { id: 11, name: "C3", isActive: 1, shade_type_id: 2 },
      { id: 12, name: "D3", isActive: 1, shade_type_id: 2 },
      { id: 13, name: "A3.5", isActive: 1, shade_type_id: 3 },
      { id: 14, name: "A4", isActive: 1, shade_type_id: 3 },
      { id: 15, name: "C4", isActive: 1, shade_type_id: 3 },
      { id: 16, name: "D4", isActive: 1, shade_type_id: 3 },
      { id: 17, name: "B4", isActive: 1, shade_type_id: 2 },
      { id: 18, name: "D4", isActive: 1, shade_type_id: 2 }
    ],
    StatusTypes: [
      {
        StatusID: 1,
        StatusName: "Created",
        StatusDesc: "Created orders",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 2,
        StatusName: "Planned",
        StatusDesc: "Planned",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 3,
        StatusName: "Approved",
        StatusDesc: "Approved",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 4,
        StatusName: "Produced",
        StatusDesc: "Produced",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 5,
        StatusName: "Shipped",
        StatusDesc: "Shipped",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        StatusID: 6,
        StatusName: "Cancelled",
        StatusDesc: "Cancelled",
        IsShowDropBox: false,
        IsShowDashboard: true
      },
      {
        StatusID: 7,
        StatusName: "OnHold",
        StatusDesc: "On Hold",
        IsShowDropBox: false,
        IsShowDashboard: null
      },
      {
        StatusID: 8,
        StatusName: "Done",
        StatusDesc: "Done",
        IsShowDropBox: false,
        IsShowDashboard: null
      },
      {
        StatusID: 9,
        StatusName: "Rejected",
        StatusDesc: "Rejected",
        IsShowDropBox: true,
        IsShowDashboard: null
      },
      {
        StatusID: 10,
        StatusName: "Draft",
        StatusDesc: "Draft",
        IsShowDropBox: false,
        IsShowDashboard: null
      }
    ],
    TiBaseMultiUnitTypes: [
      { id: 0, name: "NONE", ScrewCementType_ids: "0,1,2,3", isActive: 1 },
      { id: 1, name: "Ti-Base", ScrewCementType_ids: "0,1,2", isActive: 1 },
      { id: 2, name: "Multi-Unit", ScrewCementType_ids: "0,1,2", isActive: 1 },
      { id: 3, name: "Connect", ScrewCementType_ids: "0,1", isActive: 1 },
      { id: 4, name: "T-Blank", ScrewCementType_ids: "0,1", isActive: 1 },
      {
        id: 5,
        name: "Direct-Cylinder",
        ScrewCementType_ids: "0,1",
        isActive: 1
      },
      { id: 6, name: "Abutment", ScrewCementType_ids: "0,2", isActive: 0 }
    ],
    DiametersTypes: [
      { value: null, label: "" },
      { value: 1, label: "Ø 3.30" },
      { value: 2, label: "Ø 3.75" },
      { value: 3, label: "Ø 3.90" },
      { value: 4, label: "Ø 4.20" },
      { value: 5, label: "Ø 4.30" },
      { value: 6, label: "Ø 5" },
      { value: 7, label: "Ø 6" }
    ],
    AdditionalIndicationsTypes: [
      { id: 1, name: "Flap Less" },
      { id: 2, name: "Raised Flap" }
    ],
    DoctorInfo: {
      userID: 32,
      FirstName: "Eyal",
      LastName: "Barta",
      Email: "eyalb@mis-implants.com",
      Pass: "7FF577E7832BDBFA00A10B7664DF535A4F8F3082E96BC23DDF0875C09079B501",
      Country: "165",
      Phone: "617-323-2514",
      MobilePhone: null,
      Address: null,
      userType: 2,
      userRole: "2",
      Active: true,
      Street: "Maple st.",
      City: "West Roxbury",
      ZipCode: "02132",
      Phone2: "",
      StreetNo: "173",
      state: "",
      LastLoginTimestamps: "2020-07-23T14:21:51.74",
      LoginPasswordResetDate: null
    },
    ImpactLocationAllTeeth: [
      {
        id: 156,
        orderID: 12753,
        ThoothID: 8,
        TreatTypeID: 2,
        ToothDiameterType: 0,
        ToothImplantType: 1,
        ToothLengthType: 0,
        ToothPlatformType: null,
        ToothMaterialType: null,
        ToothRestorationType: null,
        ToothShadeType: null,
        ToothShadeTypesType: null,
        ToothBridgeCrownType: null,
        ToothScrewCementType: null,
        ToothCementedToRestorationType: null,
        ToothTiBaseMultiUnitType: null,
        ToothConcave: null,
        ToothConvex: null,
        ToothStandart: null,
        ToothOption2: null,
        ToothOption3: null,
        ToothValue: "1"
      },
      {
        id: 157,
        orderID: 12753,
        ThoothID: 7,
        TreatTypeID: 2,
        ToothDiameterType: 0,
        ToothImplantType: 2,
        ToothLengthType: 0,
        ToothPlatformType: null,
        ToothMaterialType: null,
        ToothRestorationType: null,
        ToothShadeType: null,
        ToothShadeTypesType: null,
        ToothBridgeCrownType: null,
        ToothScrewCementType: null,
        ToothCementedToRestorationType: null,
        ToothTiBaseMultiUnitType: null,
        ToothConcave: null,
        ToothConvex: null,
        ToothStandart: null,
        ToothOption2: null,
        ToothOption3: null,
        ToothValue: "3"
      },
      {
        id: 158,
        orderID: 12753,
        ThoothID: 6,
        TreatTypeID: 2,
        ToothDiameterType: 0,
        ToothImplantType: 3,
        ToothLengthType: 0,
        ToothPlatformType: null,
        ToothMaterialType: null,
        ToothRestorationType: null,
        ToothShadeType: null,
        ToothShadeTypesType: null,
        ToothBridgeCrownType: null,
        ToothScrewCementType: null,
        ToothCementedToRestorationType: null,
        ToothTiBaseMultiUnitType: null,
        ToothConcave: null,
        ToothConvex: null,
        ToothStandart: null,
        ToothOption2: null,
        ToothOption3: null,
        ToothValue: "1"
      }
    ],
    RestorationTypeAllTeeth: [
      {
        id: 159,
        orderID: 12753,
        ThoothID: 8,
        TreatTypeID: 1,
        ToothDiameterType: null,
        ToothImplantType: 1,
        ToothLengthType: null,
        ToothPlatformType: 3,
        ToothMaterialType: 2,
        ToothRestorationType: 5,
        ToothShadeType: 2,
        ToothShadeTypesType: 6,
        ToothBridgeCrownType: 1,
        ToothScrewCementType: 2,
        ToothCementedToRestorationType: 2,
        ToothTiBaseMultiUnitType: 1,
        ToothConcave: false,
        ToothConvex: false,
        ToothStandart: false,
        ToothOption2: false,
        ToothOption3: false,
        ToothValue: "1"
      },
      {
        id: 160,
        orderID: 12753,
        ThoothID: 7,
        TreatTypeID: 1,
        ToothDiameterType: null,
        ToothImplantType: 2,
        ToothLengthType: null,
        ToothPlatformType: 1,
        ToothMaterialType: 2,
        ToothRestorationType: 5,
        ToothShadeType: 2,
        ToothShadeTypesType: 8,
        ToothBridgeCrownType: 0,
        ToothScrewCementType: 0,
        ToothCementedToRestorationType: 0,
        ToothTiBaseMultiUnitType: 0,
        ToothConcave: false,
        ToothConvex: false,
        ToothStandart: false,
        ToothOption2: false,
        ToothOption3: false,
        ToothValue: "1"
      },
      {
        id: 161,
        orderID: 12753,
        ThoothID: 6,
        TreatTypeID: 1,
        ToothDiameterType: null,
        ToothImplantType: 3,
        ToothLengthType: null,
        ToothPlatformType: 2,
        ToothMaterialType: 1,
        ToothRestorationType: 3,
        ToothShadeType: 3,
        ToothShadeTypesType: 15,
        ToothBridgeCrownType: 2,
        ToothScrewCementType: 1,
        ToothCementedToRestorationType: 1,
        ToothTiBaseMultiUnitType: 1,
        ToothConcave: false,
        ToothConvex: false,
        ToothStandart: false,
        ToothOption2: false,
        ToothOption3: false,
        ToothValue: "1"
      }
    ],
    ToothTable: [
      /*
        ToothImage:
        [0] variant
        [1] options >> x (flip horizontally), y (flip vertically)
      */
      { ToothID: 1, ToothNumberADA: 1, ToothImage: [1], ToothNumberFDI: 18 },
      { ToothID: 2, ToothNumberADA: 2, ToothImage: [1], ToothNumberFDI: 17 },
      { ToothID: 3, ToothNumberADA: 3, ToothImage: [1], ToothNumberFDI: 16 },
      { ToothID: 4, ToothNumberADA: 4, ToothImage: [2], ToothNumberFDI: 15 },
      { ToothID: 5, ToothNumberADA: 5, ToothImage: [2], ToothNumberFDI: 14 },
      { ToothID: 6, ToothNumberADA: 6, ToothImage: [3], ToothNumberFDI: 13 },
      { ToothID: 7, ToothNumberADA: 7, ToothImage: [4], ToothNumberFDI: 12 },
      { ToothID: 8, ToothNumberADA: 8, ToothImage: [4], ToothNumberFDI: 11 },
      { ToothID: 9, ToothNumberADA: 9, ToothImage: [4], ToothNumberFDI: 21 },
      { ToothID: 10, ToothNumberADA: 10, ToothImage: [4], ToothNumberFDI: 22 },
      { ToothID: 11, ToothNumberADA: 11, ToothImage: [3], ToothNumberFDI: 23 },
      { ToothID: 12, ToothNumberADA: 12, ToothImage: [4], ToothNumberFDI: 24 },
      { ToothID: 13, ToothNumberADA: 13, ToothImage: [4], ToothNumberFDI: 25 },
      { ToothID: 14, ToothNumberADA: 14, ToothImage: [1], ToothNumberFDI: 26 },
      { ToothID: 15, ToothNumberADA: 15, ToothImage: [1], ToothNumberFDI: 27 },
      { ToothID: 16, ToothNumberADA: 16, ToothImage: [1], ToothNumberFDI: 28 },
      {
        ToothID: 17,
        ToothNumberADA: 32,
        ToothImage: [5, "x"],
        ToothNumberFDI: 48
      },
      {
        ToothID: 18,
        ToothNumberADA: 31,
        ToothImage: [5, "x"],
        ToothNumberFDI: 47
      },
      {
        ToothID: 19,
        ToothNumberADA: 30,
        ToothImage: [5, "x"],
        ToothNumberFDI: 46
      },
      {
        ToothID: 20,
        ToothNumberADA: 29,
        ToothImage: [2, "y"],
        ToothNumberFDI: 45
      },
      {
        ToothID: 21,
        ToothNumberADA: 28,
        ToothImage: [2, "y"],
        ToothNumberFDI: 44
      },
      {
        ToothID: 22,
        ToothNumberADA: 27,
        ToothImage: [3, "y"],
        ToothNumberFDI: 43
      },
      {
        ToothID: 23,
        ToothNumberADA: 26,
        ToothImage: [4, "y"],
        ToothNumberFDI: 42
      },
      {
        ToothID: 24,
        ToothNumberADA: 25,
        ToothImage: [4, "y"],
        ToothNumberFDI: 41
      },
      {
        ToothID: 25,
        ToothNumberADA: 24,
        ToothImage: [4, "y"],
        ToothNumberFDI: 31
      },
      {
        ToothID: 26,
        ToothNumberADA: 23,
        ToothImage: [4, "y"],
        ToothNumberFDI: 32
      },
      {
        ToothID: 27,
        ToothNumberADA: 22,
        ToothImage: [3, "y"],
        ToothNumberFDI: 33
      },
      {
        ToothID: 28,
        ToothNumberADA: 21,
        ToothImage: [2, "y"],
        ToothNumberFDI: 34
      },
      {
        ToothID: 29,
        ToothNumberADA: 20,
        ToothImage: [2, "y"],
        ToothNumberFDI: 35
      },
      { ToothID: 30, ToothNumberADA: 19, ToothImage: [5], ToothNumberFDI: 36 },
      { ToothID: 31, ToothNumberADA: 18, ToothImage: [5], ToothNumberFDI: 37 },
      { ToothID: 32, ToothNumberADA: 17, ToothImage: [5], ToothNumberFDI: 38 }
    ],
    Files: [],
    VisibleCheckToothTypes: [
      { id: 0, name: "", isActive: 1, showInMlab: 1 },
      { id: 1, name: "X", isActive: 1, showInMlab: 1 },
      { id: 2, name: "O", isActive: 1, showInMlab: 0 },
      { id: 3, name: "B", isActive: 1, showInMlab: 0 }
    ],
    McenterDetails: [
      {
        id: 4,
        McenterName: "MCENTER HQ",
        McenterAddress:
          "MIS Implant Technologies LTD, Bar-Lev indudtrial park, Misgav ISRAEL",
        McenterPhone: "+972-4-9016800",
        McenterMail: "mguide@mis-implants.com",
        McenterCreatedTimeStamp: "2019-11-12T08:57:47.32",
        McenterCreatedUserId: 1,
        isActive: 1
      },
      {
        id: 5,
        McenterName: "MCenter Europe",
        McenterAddress: "Kaiserin-Augusta Allee 112\r\n10553 Berlin\r\n",
        McenterPhone: "000",
        McenterMail: "emilb@mis-implants.com",
        McenterCreatedTimeStamp: "2020-06-25T08:12:16.513",
        McenterCreatedUserId: 1,
        isActive: 1
      }
    ]
  },
  status: { StatusCode: 200, StatusDescription: null }
};
